import React from "react";
import { useTranslation } from "react-i18next";
import { FaCheck } from "react-icons/fa6";
import { useDispatch } from "react-redux";
import useTypedSelector from "src/main/hooks/useTypedSelector";
import preference from "src/main/store/preference";

import { Language } from "src/main/types";
import "../../ChangeLanguage.css";

const ChangeLanguageContent: React.FC = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const lang = useTypedSelector((state) => state.preference.language);

  const changeLanguageHandler = (lang: string) => {
    i18n.changeLanguage(lang);
    dispatch(preference.slice.actions.setLanguage(lang));
  };

  return (
    <div>
      <div
        className={`relative h-screen w-full overflow-clip px-3 text-center text-white lg:mx-auto lg:hidden lg:max-w-md`}
      >
        <div className="flex w-full items-center justify-center pb-[31px] pt-[7px] text-center">
          <div className="text-[20px] font-bold leading-6">{t("Change Language")}</div>
        </div>
        <div
          className="h-12 cursor-pointer rounded-lg bg-[radial-gradient(84.58%_106.92%_at_83.69%_0%,#26125C_0%,#170B37_100%)] [box-shadow:1px_1px_0px_0px_rgba(137,118,255,0.24)_inset]"
          onClick={() => changeLanguageHandler(Language.EN)}
        >
          <div className="flex h-full items-center justify-center gap-[10px] px-4 py-[14px]">
            <img
              className="w-[25px]"
              src="/images/icon/flag-en.svg"
              alt="English-Language"
            />
            <div className="shrink grow">
              <p className="text-left text-[14px] font-bold leading-4">English</p>
            </div>
            {lang === Language.EN ? <FaCheck className="h-[10px] w-[10px]" /> : <div className="h-[10px] w-[10px]" />}
          </div>
        </div>

        <div
          className="mt-2 h-12 cursor-pointer rounded-lg bg-[radial-gradient(84.58%_106.92%_at_83.69%_0%,#26125C_0%,#170B37_100%)] [box-shadow:1px_1px_0px_0px_rgba(137,118,255,0.24)_inset]"
          onClick={() => changeLanguageHandler(Language.TH)}
        >
          <div className="flex h-full items-center justify-center gap-[10px] px-4 py-[14px]">
            <img
              className="w-[25px]"
              src="/images/icon/flag-th.svg"
              alt="English-Language"
            />

            <div className="shrink grow">
              <p className="text-left text-[14px] font-bold leading-4">{t("Thailand")}</p>
            </div>

            {lang === Language.TH ? <FaCheck className="h-[10px] w-[10px]" /> : <div className="h-[10px] w-[10px]" />}
          </div>
        </div>
      </div>

      <div className="hidden lg:block">
        <div className="w-1/3 flex-initial">
          <div
            className={`${lang === Language.TH ? "font-semibold" : ""} no-tap-highlight mt-2 w-full cursor-pointer text-left text-[20px]`}
            onClick={() => changeLanguageHandler(Language.TH)}
          >
            <div className="flex h-full items-center rounded-3xl border-2 border-[rgba(153,182,255,0.5)] bg-black px-3">
              <div className="w-14 flex-none">
                <img
                  className="w-[25px]"
                  src="/images/icon/flag-th.svg"
                  alt="English-Language"
                />
              </div>
              <div className="w-64 shrink">
                <p className="my-3 text-[15px]">{t("Thailand")}</p>
              </div>
              <div className="ml-2 w-8 flex-none">
                {lang === Language.TH ? (
                  <img
                    src="/images/icon/ico-check.svg   "
                    alt="Selected Languange"
                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>

          <div
            className={`${lang === Language.EN ? "font-semibold" : ""} no-tap-highlight mt-2 w-full cursor-pointer text-left text-[20px]`}
            onClick={() => changeLanguageHandler(Language.EN)}
          >
            <div className="flex h-full items-center rounded-3xl border-2 border-[rgba(153,182,255,0.5)] bg-black px-3 py-3">
              <div className="w-14 flex-none">
                <img
                  className="w-[25px]"
                  src="/images/icon/flag-en.svg"
                  alt="English-Language"
                />
              </div>
              <div className="w-64 shrink">
                <p className="text-[15px]">English</p>
              </div>
              <div className="w-8 flex-none">
                {lang === Language.EN ? (
                  <img
                    src="/images/icon/ico-check.svg"
                    alt="Selected Languange"
                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangeLanguageContent;
